import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { JackpotAnalysisPage } from "@/components/JackpotAnalysisPage";
import { jackpotAnalysisFaqs } from "@/data/jackpot-analysis";

const faqs = jackpotAnalysisFaqs("Mega Millions");

export const Route = createFileRoute("/mega-millions/jackpot-analysis")({
  head: () =>
    buildSeo({
      title: "Mega Millions Payout Calculator: State-by-State Lump Sum vs Annuity",
      description:
        "Mega Millions jackpot analysis: cash value vs annuity, federal and state tax breakdown, and net take-home payouts for all 50 states.",
      path: "/mega-millions/jackpot-analysis",
      type: "article",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        },
      ],
    }),
  component: () => (
    <JackpotAnalysisPage
      game="Mega Millions"
      input={{ advertisedJackpot: 100_000_000, cashRatio: 0.5 }}
      faqs={faqs}
      intro="See exactly what a Mega Millions jackpot pays after federal and state taxes, with a side-by-side comparison of the cash lump sum and the 30-year annuity for every U.S. state."
      drawingsText="Drawings are held Tuesday and Friday at 11:00 PM ET. Tickets cost $5 per play (effective April 2025) and include a built-in multiplier."
      oddsText="Jackpot odds: 1 in 290,472,336. Overall odds of winning any prize: 1 in 23."
    />
  ),
});